import betterwe from '@/common/app-common.js'
import VueRouter from 'vue-router'
import wxAuthManager from '@/common/wx-auth.js'
let betterweHistory = []
/* 返回到指定url */
/* VueRouter.prototype.backToUrl = function (location) {
    let url;
    if(typeof location == "string"){
        url = location.split("?")[0];
    }else if( typeof location == "object" ){
        url = location.path;
    }
    if(url){
        for(let i= betterweHistory.length -1;i >= 0;i--){
            if(betterweHistory[i].path == url){
                let backIndex = betterweHistory.length - 1 - i;
                backIndex > 0 && VueRouter.go(backIndex);
            }
        }
    }
  return VueRouter.go();
} */
//新增全局函数判断webview是否能返回
window.canGoBack = function () {
  return window.history.length
}
const changeWebview = function (params) {
  betterwe.initWebViewUIConfig(params)
}
//配置webview的状态栏等
const setWebview = function (to) {
  //如果两个都没有就不配置webview
  if (!to.meta.title && !to.meta.webview) {
    return
  }
  let params = {}
  params.title = to.meta.title
  if (to.meta.webview && typeof to.meta.webview === 'object') {
    for (let i in to.meta.webview) {
      params[i] = to.meta.webview[i]
    }
  }
  changeWebview(params)
}
const beforeEachFunction = (to, from, next) => {
  // 合法性校验
  if (to.meta.title) document.title = to.meta.title
  //如果路由中有webview参数则会进行配置
  setWebview(to)

  // 兼容原有的 auth 检查
  if (to.meta.auth) {
    // console.log("into auth", to.meta);
    next()
  }
  next()
}
export { beforeEachFunction }
